module.exports = __webpack_public_path__ + "static/media/heroSectionBackground.06bca2d3.png";